import COLORS from './colors';

export const SOURCE_TYPE_COLORS = {
  dashboard: COLORS.green,
  teams: COLORS.blue,
  web: COLORS.orange,
};

const smartAssistQueriesBySourceChartConfig = {
  title: 'Questions by interface',
  helpText: 'metrics_tab.smart_assist_tab.overview_tab.queries_by_source.help_text',
  exportType: 'tabular_chart_data',
  graphParams: {
    dataNameField: 'name',
    dataValueField: 'value',
    // d3 external legend at the top — toggleable swatch + label items,
    // matches the pattern used by the Daily question volume chart. The c3
    // built-in legend stays off (default) so the donut has only one legend.
    showExternalLegend: true,
  },
};

export default smartAssistQueriesBySourceChartConfig;
